import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Check icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/check?f=classic&s=solid
 */
export const CheckIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCheck} {...props} />;
};
